export enum UploadVisibilityTypeEnum {
  ALL = "all",
  PRIVATE = "private",
  ORGANISATION = "organisation",
  MARKET = "market",
}
